import React from 'react'
import { Tag, Button } from 'antd'
import { parseDateOnly, isExpectedCompletionPast, isReviewDatePast } from './utils'
import './styles.css'

function StatusFilters({
  activeFilterTypes,
  enabledFilterValues,
  jobCards,
  searchTerm,
  showUnserviceableOnly,
  showExpiredOnly,
  showClosedPIOnly,
  onToggleFilterValue,
  onSelectAll,
  onSelectNone,
  getFilterFieldName,
  getFilterValue,
  getFilterTypeLabel
}) {
  const getDynamicCount = (filterType, value) => {
    let count = 0

    jobCards.forEach((card) => {
      const cardValue = getFilterValue(card, filterType)
      if (cardValue !== value) {
        return
      }

      if (searchTerm) {
        const haystack = (
          card.jobCardNo +
          ' ' +
          card.detailsOfComplaint +
          ' ' +
          card.assetType +
          ' ' +
          card.assetSubType +
          ' ' +
          card.assetCode +
          ' ' +
          card.location +
          ' ' +
          card.subLocation
        ).toLowerCase()
        if (!haystack.includes(searchTerm.toLowerCase())) {
          return
        }
      }

      let matchesOtherFilters = true
      for (const otherFilterType of activeFilterTypes) {
        if (otherFilterType === filterType) {
          continue
        }

        const cardOtherValue = getFilterValue(card, otherFilterType)

        if (!enabledFilterValues.has(otherFilterType)) {
          continue
        }

        const enabledOtherValues = enabledFilterValues.get(otherFilterType)

        const allOtherValues = new Set()
        jobCards.forEach((c) => {
          const val = getFilterValue(c, otherFilterType)
          if (val) allOtherValues.add(val)
        })

        if (enabledOtherValues.size > 0 && enabledOtherValues.size < allOtherValues.size) {
          if (!enabledOtherValues.has(cardOtherValue)) {
            matchesOtherFilters = false
            break
          }
        }
      }

      if (showUnserviceableOnly) {
        const isUnserviceable = (card.assetUnservicable || '').toString().toLowerCase().trim() === 'true'
        if (!isUnserviceable) {
          matchesOtherFilters = false
        }
      }

      if (showExpiredOnly) {
        if (!isReviewDatePast(card)) {
          matchesOtherFilters = false
        }
      }

      if (showClosedPIOnly) {
        if ((card.statusTitle || '').trim() !== 'ClosedPendingInvoice') {
          matchesOtherFilters = false
        }
      }

      if (matchesOtherFilters) {
        count++
      }
    })

    return count
  }

  if (activeFilterTypes.size === 0) {
    return null
  }

  return (
    <div className="status-filters-row">
      {Array.from(activeFilterTypes).map((filterType) => {
        const allValues = new Set()
        jobCards.forEach((c) => {
          const value = getFilterValue(c, filterType)
          if (value) {
            allValues.add(value)
          }
        })

        const sortedValues = Array.from(allValues).sort((a, b) => a.localeCompare(b))
        const enabledValues = enabledFilterValues.get(filterType) || new Set()

        return (
          <div key={filterType} className="filter-section">
            <div className="filter-section-header">
              <span>{getFilterTypeLabel(filterType)}</span>
              <div className="filter-section-actions">
                <Button
                  type="link"
                  size="small"
                  onClick={() => onSelectAll(filterType)}
                  style={{ fontSize: '10px', padding: '2px 6px', height: 'auto', marginBottom: 0 }}
                >
                  Select All
                </Button>
                <Button
                  type="link"
                  size="small"
                  onClick={() => onSelectNone(filterType)}
                  style={{ fontSize: '10px', padding: '2px 6px', height: 'auto', marginBottom: 0 }}
                >
                  Select None
                </Button>
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {sortedValues.map((value) => {
                const dynamicCount = getDynamicCount(filterType, value)
                if (dynamicCount === 0) return null

                const isActive = enabledValues.has(value)

                return (
                  <Tag
                    key={value}
                    color={isActive ? 'blue' : ''}
                    onClick={() => onToggleFilterValue(filterType, value)}
                    style={{
                      cursor: 'pointer',
                      // fontSize: '8px',
                      // padding: '4px 7px',
                      borderRadius: '25px',
                      // marginBottom: '2px'
                      transition: 'all 0.15s ease'
                    }}
                  >
                    {value} <span style={{ fontWeight: 600 }}>{dynamicCount}</span>
                  </Tag>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default StatusFilters

